export default function FieldRow({
  label,
  value,
  editing,
  type = "text",
  onChange,
  children,
}: {
  label: string;
  value: string;
  editing: boolean;
  type?: string;
  onChange?: (value: string) => void;
  children?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
      <span
        className="text-[12px] text-slate-500 min-w-24 flex-shrink-0"
        style={{ fontWeight: 500 }}
      >
        {label}
      </span>
      {editing && children ? (
        children
      ) : editing ? (
        <input
          type={type}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className="flex-1 px-3 py-2 w-full rounded-xl border border-slate-200 bg-white text-slate-800 text-[13px] outline-none focus:border-violet-400 focus:ring-2 focus:ring-violet-100 transition-all"
          style={{ fontFamily: "Inter, sans-serif", fontWeight: 400 }}
        />
      ) : (
        <span
          className="text-[14px] text-slate-800"
          style={{ fontWeight: 500 }}
        >
          {value || "—"}
        </span>
      )}
    </div>
  );
}
